import React from 'react';
import { alpha, styled } from '@mui/material/styles';
import Popover, { PopoverProps } from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import { NavItem } from '../../nav';
import { SideNavMenu } from './SideNavMenu';

type Props = {
  anchorTopPosition: number;
  headerHeight?: number;
  isAuthenticated?: boolean;
  isPrimary?: boolean;
  onNavItemClick: (item: NavItem, level: number) => void;
  onNavItemHover: (item: NavItem, level: number) => void;
  openItems: NavItem[];
} & Omit<PopoverProps, 'children'>;

type PaperProps = {
  headerHeight?: number;
};

export function SideNavPopover(props: Props) {
  const {
    anchorTopPosition,
    headerHeight,
    isAuthenticated,
    isPrimary = false,
    onNavItemClick,
    openItems = [],
    onNavItemHover,
    ...others
  } = props;

  return (
    <StyledPopover
      {...others}
      PaperProps={{
        sx: {
          '&::-webkit-scrollbar': {
            width: '6px !important',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#C4C4C4',
          },
          '&::-webkit-scrollbar-track': {
            boxShadow: 'none !important',
          },
          borderRadius: 0,
          height: '100%',
          overflow: 'hidden',
          top: `0px !important`,
        },
      }}
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'top',
      }}
      elevation={3}
      headerHeight={headerHeight}
      marginThreshold={0}
      transformOrigin={{
        horizontal: 'left',
        vertical: 'top',
      }}
    >
      <StyledStack direction="row" isPrimary={isPrimary}>
        {openItems.map((openItem, index) => {
          const level = index + 1;

          return (
            <SideNavMenu
              data-testid={`${openItem.key}`}
              isAuthenticated={isAuthenticated}
              isPrimary={isPrimary}
              key={openItem.key}
              level={level}
              navItem={openItem}
              onNavItemClick={onNavItemClick}
              onNavItemHover={onNavItemHover}
            />
          );
        })}
      </StyledStack>
    </StyledPopover>
  );
}

interface AvailabilityProps {
  isPrimary?: boolean;
}

const StyledStack = styled(Stack, {
  shouldForwardProp: (props) => props !== 'isPrimary',
})<AvailabilityProps>(({ isPrimary, theme }) => ({
  backgroundColor: isPrimary
    ? theme.palette.common.white
    : theme.palette.neutral[10],
  borderLeft: `ridge 0.5px ${theme.palette.grey[300]}`,
  height: '100%',
  width: '100%',
}));

const StyledPopover = styled(Popover)<PaperProps>(
  ({ headerHeight, theme }) => ({
    backgroundColor: alpha(theme.palette.common.black, 0.4),
    height: '100%',
    top: headerHeight,
    zIndex: 100,
  })
);
